import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Splash-NFT" link="https://Splash-nft.netlify.app/" bg="linear-gradient(to right, #D585EC 0%, #00FFEE 100%)" mdxType="ProjectCard">
  An NFT store to sell and buy NFTs using MATIC. Built with Next.js, Solidity,
  Tailwind css and hardhat on the Mumbai network.
    </ProjectCard>
    <ProjectCard title="Geodash" link="https://geo-dash.netlify.app/" bg="linear-gradient(to right, #D575FF 0%, #00DFEE 100%)" mdxType="ProjectCard">
  A travel companion app that gives you a review of the best restaurants, hotels
  and attractions. Built with React, Material UI, Google Maps API, Rapid API's
  Travel advisor and Weather APIs.
    </ProjectCard>
    <ProjectCard title="Space Tourism" link="https://astro-tour.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  My implementation of the space-tourism frontendmentor challenge using React.js
  and sass.
    </ProjectCard>
    <ProjectCard title="Andy's Coffee Delight" link="https://andys-coffee-delight.netlify.app/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  An online coffee shop that allows users to order coffee as well as other
  beverages. The site is built with Gatsby.js, Contentful, GraphQL, Snipcart and
  bootstrap.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      